import { McTooltip } from '@maersk-global/mds-react-wrapper';

export default function RemarksRenderer({ remarks }: { remarks: string }) {
  if (remarks.length <= 30) {
    return <span style={{ whiteSpace: 'pre-wrap' }}>{remarks}</span>;
  }

  return (
    <McTooltip appearance="neutral-default" width={400}>
      <span slot="trigger" style={{ whiteSpace: 'pre-wrap' }}>
        {remarks.slice(0, 30)}...
      </span>
      <span style={{ whiteSpace: 'pre-wrap' }}>{remarks}</span>
    </McTooltip>
  );
}
